export default __webpack_public_path__ + "static/media/sports-hover.7b5099bf.webp";